import img from './Metamask.png'
const MetaMask = ()=>{
    return(
        <img src={img}/>
    )
}

export default MetaMask